<template>
	<div id="directa-container">
		<div id="payment-type-container">
			<span>{{ languageStrings.documentType}}</span>
			<select
				class="curved-border encore-color bold-text extra-padding-text-fields"
				id="doc-type-select"
				v-model="docType"
			>
				<option value="PASS">{{ languageStrings.passport }}</option>
				<option value="CURP">CURP</option>
				<option value="IFE">IFE</option>
				<option value="RFC">RFC</option>
			</select>
			<label for="doc-number">{{ languageStrings.documentId }}</label>
			<input
				type="text"
				class="curved-border encore-color bold-text padding-for-input center-text"
				id="doc-number"
				v-model="docNumber"
			/>
		</div>
		<div class="center-content">
			<input
				type="checkbox"
				id="terms-and-conditions"
				name="terms-and-conditions"
				title="Terms And Conditions"
				v-model="termsAndConditions"
			/>
			<label for="termsAndConditions" title="Terms And Conditions" class="terms-and-conditions-font">{{ languageStrings.checkingBoxAgreeTerms }}<a @click="getTermsAndConditions()" class="center-content" style="color: white; margin-bottom: 1%; font-size: xx-small;">{{ languageStrings.termsAndConditions }}</a></label>
			<div v-if="showTermsAndConditions">
				<TermsAndConditions
					:playerState="playerState"
					:languageStrings="languageStrings"
					:languageErrorStrings="languageErrorStrings"
					:tosContent="tosContent"
					:latestVersion="latestVersion"
					:showAcceptAndContinue="false"
				/>
			</div>
		</div>
		<div class="button-container" :class ="restrictedNeedsMoreInfo&&
							fromPlayerCashCOC >=  webPayOptions.taxAmlRestrictions.buyInThresholdCOC || !termsAndConditions || fromPlayerCashCOC > playerLimit  ? 'disable-container' : ''">
			<button class="btn buy-in-btn curved-border" :disabled="restrictedNeedsMoreInfo &&
							fromPlayerCashCOC >=  webPayOptions.taxAmlRestrictions.buyInThresholdCOC || !termsAndConditions || fromPlayerCashCOC > playerLimit" :id="`commit-offer${buyInOffer.id}`" @click="order()">
				{{ languageStrings.commitTransaction }}
			</button>
		</div>
		<div id="directa-iframe-container" v-if="iframeSrc">
			<iframe id="directa-iframe" :src="iframeSrc"></iframe>
			<div id="btn-container">
				<router-link class="btn" title="View Transactions" to="/webPayTransactions">
					{{ languageStrings.viewTransactions }}
				</router-link>
				<router-link class="btn" :title="languageStrings.viewBalances" to="/">{{
					languageStrings.viewBalances
				}}</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import { onBeforeUnmount } from "vue";
import sharedScripts from "@/dependencies/sharedScripts";
import router from "@/router";
import TermsAndConditions from "@/components/TermsAndConditions";

export default {
	name: "Directa",
	props: {
		playerState: Object,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		webPayOptions: Object,
		isMobile: Boolean,
		buyInOffer: Object,
		fromPlayerCashCOC: Number,
		restrictedNeedsMoreInfo: Boolean,
		provider: String,
		paymentMethodCode: String,
		playerLimit: Number
	},
	components: {
		TermsAndConditions
	},
	data() {
		return {
			activeSession: this.session.get(),
			status: Object.assign({}, this.globalStatus),
			currencyInfo: this.playerState.currencyInfo,
			systemCurrencyInfo: this.systemCurrencyTool.currencyInfo,
			minorOrFull: this.systemCurrencyTool.displayType.minorOrFull,
			paymentType: "",
			docNumber: null,
			docType: null,
			iframeSrc: null,
			statuses: [
				"failedAuthentication",
				"buyInAmountEmpty",
				"valueIsNotANumber",
				"meetMinimumBuyInAmount",
				"exceededMaximumBuyInAmount",
				"completeNeoCheck",
				"IdCheckRequired",
				"EmailNotVerified",
				"fetchStatusGood",
				"webPayIniateFailed",
				"Success",
				"RejectedByPaymentService"
			],
			tosContent:"",
			latestVersion: {},
			termsAndConditions: false,
			showTermsAndConditions: false,
		};
	},
	created() {
		
		window.document.addEventListener("transactionComplete", this.handlePaySuccess, false);
		window.document.addEventListener("transactionFailed", this.handlPayFailure, false);
		onBeforeUnmount(() => {
			window.document.removeEventListener("transactionComplete", this.handlePaySuccess, false);
			window.document.removeEventListener("transactionFailed", this.handlPayFailure, false);
		});
		this.eventBus.on("closeTos", () => {
			this.showTermsAndConditions = false;
		});
	},
	methods: {
		handlePaySuccess() {
			this.iframeSrc = "";
			this.status.ok = true;
			this.status.message = this.languageErrorStrings.success;
			this.eventBus.emit("updateStatus", this.status);
			router.push("/webPayTransactions");
		},
		handlPayFailure() {
			this.iframeSrc = "";
			this.status.ok = false;
			this.status.message = this.languageErrorStrings.somethingWentWrongTryLater;
			this.eventBus.emit("updateStatus", this.status);
		},
		async order() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.initiatingBuyIn;

			let hasErrors = false;
			this.eventBus.emit("checkForSpamRequest");

			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				//failedAuthentication
				return this.handleStatusMessage(this.statuses[0]);
			}

			//buyInAmountEmpty
			if (!this.fromPlayerCashCOC) return this.handleStatusMessage(this.statuses[1]);


			//valieIsNotANumber
			if (isNaN(this.fromPlayerCashCOC)) return this.handleStatusMessage(this.statuses[2]);
			

			//meetMinimumBuyInAmount
			if (this.fromPlayerCashCOC < this.buyInOffer.minimumCOC) return this.handleStatusMessage(this.statuses[3]);

			let maxCOC =
				this.webPayOptions?.taxAmlRestrictions?.idCheckNeeded ||
				this.webPayOptions?.taxAmlRestrictions?.morePersonalInfoNeeded
					? this.webPayOptions?.taxAmlRestrictions?.cashOutThresholdCOC
					: this.webPayOptions?.directa?.cashOutMaximumCOC;

			//exceededMaximumBuyInAmount
			if (this.fromPlayerCashCOC > this.buyInOffer.maximumCOC) return this.handleStatusMessage(this.statuses[4]);

			if (this.provider === "directa" && this.fromPlayerCashCOC < this.webPayOptions?.directa?.buyInMinimumCOC) {
				this.serverBusy = false;
				this.busyText = "";
				this.status.ok = false;
				this.status.message = `${this.webPayOptions?.directa?.buyInMinimumCOC} ${this.languageErrorStrings.minimumForDirectaBuyIn}`;
				this.eventBus.emit("updateStatus", this.status);
				return false;
			}

			if (this.fromPlayerCashCOC > maxCOC) {
				//completeNeoCheck
				router.push("/identificationStatus");
				return this.handleStatusMessage(this.statuses[5],maxCOC);
			}

			if (hasErrors === true) return;

			// We're cheating on this.  We *need* to supply URLs for back, success, and error - they're mandatory.  However,
			// the request will be rejected if they're not HTTPS.  So if we're running locally, which is the expected case
			// We might have to lie about our address.
			const redirectUrlBase = window.location.origin.startsWith("https")
				? window.location.origin
				: window.location.origin.replace("http", "https");

			let body = {
				casinoId: this.webPayOptions.casino.id,
				buyInOfferId: this.buyInOffer.id,
				fromPlayerCashCOC: this.fromPlayerCashCOC,
				provider: "Directa",
				directa: {
					documentNumber: this.docNumber,
					documentType: this.docType,
					paymentMethodCode: this.paymentMethodCode,
					backUrl: `${redirectUrlBase}/webPayCashOut/cashout-finished.html?ppp_status=PENDING`,
					successUrl: `${redirectUrlBase}/webPayCashOut/cashout-finished.html?ppp_status=OK`,
					errorUrl: `${redirectUrlBase}/webPayCashOut/cashout-finished.html?ppp_status=FAIL`,
				},
			};

			let requestUrl = new URL("/api/v1/webpay/buyin/initiate", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				const response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);
				
				if (fetchStatus && !fetchStatus.ok) {
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout === true) this.eventBus.emit("forceLogout");
					return;
				}

				this.transaction = await response.json();

				if (this.transaction?.status === this.statuses[7]) {
					console.error(this.transaction?.status);
					//EmailNotVerified
					this.handleStatusMessage(this.statuses[7]);
					return;
				}
				
				if (this.transaction?.status === this.statuses[11]) {
					console.error(this.transaction?.status);				
					//RejectedByPaymentService
					this.handleStatusMessage(this.statuses[11]);
				}

				//fetchStatusGood
				if (fetchStatus.ok) this.handleStatusMessage(this.statuses[8],null, this.transaction);
					
				if (this.status.ok) {
					this.iframeSrc = this.transaction.redirectUrl;
					//Success
					this.handleStatusMessage(this.statuses[10]);
				}
			} catch (e) {
				//webPayIniateFailed
				this.handleStatusMessage(this.statuses[9]);
				console.error(e);
			}
		},

		handleStatusMessage(causeOfMessage, maxCOC = null, transaction = null){
			this.serverBusy = false;
			this.busyText = "";

			//failedAuthentication
			if(causeOfMessage === this.statuses[0]) return false;
	
			this.status.ok = false;
			if(causeOfMessage === this.statuses[8]){
				//fetchStatusGood
				this.status = sharedScripts.checkSuccessErrors(transaction.status, this.languageErrorStrings);
				this.eventBus.emit("updateStatus", this.status);
			}
			else{
				this.status.message = sharedScripts.statusMessage(causeOfMessage, this.languageErrorStrings, this.systemCurrencyTool,maxCOC);
				this.eventBus.emit("updateStatus", this.status);
			}
			return false;
		},
		async updateRfTranSatus(newStatus) {
			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				//failedAuthentication
				return this.handleStatusMessage(this.statuses[0]);
			}

			let body = {
				webTranId: this.transaction.transaction.id,
				newStatus: newStatus,
			};

			let requestUrl = new URL("/api/v1/webpay/transaction/update", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				const response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout === true) this.eventBus.emit("forceLogout");
					return;
				}

				let rfRequestStatus = await response.json();

				if (fetchStatus.ok)
					this.status = sharedScripts.checkSuccessErrors(this.transaction.status, this.languageErrorStrings);
			} catch (e) {
				//webPayIniateFailed
				this.handleStatusMessage(this.statuses[9]);
				console.error(e);
			}
		},
		getTermsAndConditions() {
			this.getLatestTosDocument();
		
		},
		async getLatestTosDocument() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.loadingTermsAndConditions;
			// this.tosList = "testing test";
			// this.tosContent = "done testing";
			// console.log("this si the tos list", this.tosList);
			//here for testing purposes
			
			try {
				this.tosList = await this.listDocuments(this,"tos", 10);
				if (!this.tosList?.length > 0) {
					this.serverBusy = false;
					this.busyText = "";
					this.status.message = "There are no tos files avaliable";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				}
				this.latestVersion = this.compareDocumentVersions(this.tosList);

				let documentUrl =
					this.latestVersion.url.indexOf("http") === 0
						? this.latestVersion.url
						: `./${this.latestVersion.url}`;

				let content = await fetch(documentUrl);
				let dataJson = await content.text();
				this.tosContent = this.removeScriptTag(dataJson);
				this.showTermsAndConditions = true;

				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				console.error(e);
				this.serverBusy = false;
				this.busyText = "";
				this.status.ok = false;
				this.status.message = e;
				this.eventBus.emit("updateStatus", this.status);
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#payment-type-container {
	display: flex;
	flex-flow: column;
	text-align: center;
}

#payment-type-container,
#payment-type-container span {
	margin: 15px;
}

#directa-iframe-container {
	display: grid;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background-color: rgb(0 0 0 / 84%);
	backdrop-filter: blur(6px);
	z-index: 100;
	overflow: hidden auto;
}

iframe#directa-iframe {
	height: 80vh;
	width: 90vw;
}

#btn-container {
	text-align: center;
	display: flex;
	flex-flow: row;
	align-items: center;
	justify-content: space-evenly;
}

.btn {
	text-decoration: none;
}

.buy-in-btn {
	width: 100%;
	height: 100%;
	margin: 0;
}
select {
	height: 35px;
}

input {
	height: 35px;
}

.padding-for-input {
	padding-left: 15px;
}

button.btn:disabled {
	background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3)) !important;
	color: light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3)) !important;
	border-color: light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3)) !important;
}

.disable-container {
	opacity: .9 !important;
}

.terms-and-conditions-font {
	font-size: xx-small;
}

.center-content {
	display: flex;
	justify-content: center;
}
a:hover {
	cursor: pointer;
}

a {
	text-decoration: underline;
}

@media (min-width: 768px) {
	#directa-iframe-container {
		width: 80%;
		left: 20%;
	}

	iframe#directa-iframe {
		width: 50vw;
	}
}
</style>
